import React from 'react';
import {SafeAreaView} from 'react-native-safe-area-context';
import {Platform, Text, View} from 'react-native';
import {Camera} from 'expo-camera';
import ModalOmniBar from 'src/Modules/OmniBars/ModalOmniBar';
import {navigationRef} from 'src/Nav/navigationHelpers';
import useParams from 'src/Hooks/useParams';

const QrModal = () => {
  const {handleBarCodeRead, text} = useParams();

  return (
    <SafeAreaView
      style={{
        backgroundColor: global?.color?.white,
        flex: 1,
        position: 'relative',
      }}>
      <View style={{flex: 1}}>
        <View
          style={{
            marginTop: Platform.OS === 'android' ? 10 : 40,
            justifyContent: 'center',
            backgroundColor: global?.color?.white,
            marginBottom: 10,
            paddingBottom: 5,
          }}>
          <Text
            style={{
              fontFamily: global?.font.circular,
              color: global?.color?.gray3,
              textAlign: 'center',
              fontSize: 24,
            }}>
            {text}
          </Text>
        </View>
        <Camera
          style={{flex: 1}}
          onBarCodeScanned={(data) => handleBarCodeRead(data)}
        />
      </View>
      <ModalOmniBar
        omniButton={{
          handlePress: () => navigationRef.goBack(null),
          text: 'Cancel',
        }}
      />
    </SafeAreaView>
  );
};

export default QrModal;
